export default "__VITE_ASSET__DdtC1Q_H__"